import ReactMarkdown from 'react-markdown';
import { Fragment } from 'react/jsx-runtime';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';
import Typewriter from 'typewriter-effect';
import showdown from 'showdown';
import LinkPreview from './LinkPreview';
import useSessionMessages from 'screens/hooks/useSessionMessages';
import useLocalStorage from 'hooks/useLocalStorage';
import useSessionStorage from 'hooks/useSessionStorage';
import { BOT_SESSION_ID, CHAT_MESSAGES } from 'constant/chat';

const StyledMarkdown = styled(ReactMarkdown)`
    ul,
    ol {
        list-style-type: disc;
        padding-left: 20px;
    }

    li li {
        margin-left: 20px;
    }
`;

const MarkdownComponent = ({ children }) => {
    const processedChildren = children?.replace(/\n/g, '<br />');
    const { getSessionMessages } = useSessionMessages();
    const { getLocalStorageValue, removeLocalStorageValue, setLocalStorageValue } = useLocalStorage();
    const { getSessionStorageValue, replaceSessionStorageValue } = useSessionStorage();

    const extractFirstLinkFromMarkdown = (markdown) => {
        const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/; // Markdown link pattern [text](url)
        const match = markdown.match(linkRegex);

        if (match && match[2]) {
            return {
                text: match[1], // The text inside the square brackets
                url: match[2] // The URL inside the parentheses
            };
        }
        return null;
    };

    const firstLink = extractFirstLinkFromMarkdown(processedChildren);

    const handleLinkClick = (event, href) => {
        try {
            const currentSessionId = getSessionStorageValue(BOT_SESSION_ID);
            setLocalStorageValue(BOT_SESSION_ID, currentSessionId);
            setLocalStorageValue('BOT_LINK_NAVIGATION', 'true'); // Add flag to indicate navigation from bot
            getSessionMessages().then((response) => {
                setLocalStorageValue(CHAT_MESSAGES, response.chatMessages);
            });
        } catch (error) {
            console.error('Error preserving session data:', error);
        }
    };

    // var converter = new showdown.Converter();
    // var html = converter.makeHtml(processedChildren);

    return (
        <Fragment>
            {/* <Typewriter
            options={{
                strings: html,
                autoStart: true,
                loop: false,
                delay: 2,
            }}
        /> */}
            <StyledMarkdown
                components={{
                    a: ({ href, children }) => {
                        return (
                            <Fragment>
                                <a
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={href}
                                    onClick={(event) => handleLinkClick(event, href)}>
                                    {children}
                                </a>
                                <LinkPreview url={href} handleLinkClick={handleLinkClick} />
                            </Fragment>
                        );
                    }
                }}
                linkTarget={'_blank'}
                rehypePlugins={[rehypeRaw, remarkGfm]}
                children={processedChildren}
            />
            {/* {firstLink && <LinkPreview url={firstLink.url} />} */}
        </Fragment>
    );
};

export default MarkdownComponent;
